export const productInfo = {
  fullName: "Purrfect Pinot Noir",
  name: "Purrfect Pinot Noir",
  subtitle: "Wine Bottle Cat Scratcher",
  tagline: "Stylish Scratching Solution for Cats",
  description:
    "A wine bottle-shaped cat scratcher that brings elegance to your home. Wrapped in natural jute rope for satisfying scratching, built on a sturdy wood base for stability, and topped with a playful ball toy. Simple 3-step assembly — no tools needed beyond the included Allen wrench.",
  dimensions: {
    height: '22.6"',
    width: '12.8"',
    heightCm: "57.5 cm",
    widthCm: "32.5 cm",
  },
  itemNumber: "1935078",
  material: "Natural Jute Rope + Sturdy Wood Base",
  weight: "Lightweight",
  assembly: "3-Step Easy Assembly",
  colors: [
    { name: "Cabernet Red", value: "#8B1A1A", label: "Red" },
    { name: "Merlot Brown", value: "#5C3A21", label: "Brown" },
  ],
  images: {
    hero: "https://storage.readdy-site.link/project_files/dae852f0-bc8c-4b6c-a2f0-050ba5ecef67/3ad69e8a-b263-481c-836a-836d81752e7c_1.jpg?v=469ef8a3c6fef635d36c728769abc9e3",
    detail1:
      "https://storage.readdy-site.link/project_files/dae852f0-bc8c-4b6c-a2f0-050ba5ecef67/8bf7117d-cf46-4008-8169-28b3e282bfef_3.jpg?v=3b9d82ca811c78a5a30016599ae6fc14",
    detail2:
      "https://storage.readdy-site.link/project_files/dae852f0-bc8c-4b6c-a2f0-050ba5ecef67/8aa19551-14da-47b6-9e48-d1f9d359b037_4.jpg?v=626132fd877074b065457caf75198ae4",
    detail3:
      "https://storage.readdy-site.link/project_files/dae852f0-bc8c-4b6c-a2f0-050ba5ecef67/ec64acfe-b36c-40c9-acd4-91d26246d296_5.jpg?v=6f760cc75a2d07052a794f302f091d5d",
  },
};

export const sellingPoints = [
  {
    id: 1,
    title: "Wine Bottle Design",
    description:
      "A sleek wine bottle silhouette that complements modern home decor while giving your cat a dedicated scratching spot.",
    image: "https://static.readdy.ai/image/d70d14e642c2c6f5d3cb475f694c0196/4809cf0a83339596ec5446fbca961bdd.png",
    cta: "Find at Costco",
  },
  {
    id: 2,
    title: "Natural Jute Rope",
    description:
      "Premium natural jute rope wrapping satisfies your cat's instinct to scratch. Durable, wear-resistant, and earth-friendly.",
    image: "https://static.readdy.ai/image/d70d14e642c2c6f5d3cb475f694c0196/f11a6397dc01ed7f6f47745e70a673da.png",
    cta: "Learn More",
  },
  {
    id: 3,
    title: "3-Step Assembly",
    description:
      "Everything you need is in the box. Simply attach the bottle post to the base, tie on the ball, and stick the anti-slip pads.",
    image: "https://static.readdy.ai/image/d70d14e642c2c6f5d3cb475f694c0196/4809cf0a83339596ec5446fbca961bdd.png",
    cta: "Learn More",
  },
];

export const features = [
  {
    id: 1,
    name: "Natural Jute Rope",
    description: "Premium natural fibers\nSatisfies scratching instinct",
    param: "Full Wrap",
    image: "https://readdy.ai/api/search-image?query=Close-up%20macro%20photograph%20of%20thick%20natural%20jute%20rope%20texture%20wrapped%20around%20a%20cylinder%2C%20warm%20amber%20brown%20tones%2C%20soft%20studio%20lighting%2C%20detailed%20fiber%20texture%2C%20organic%20earthy%20material%2C%20clean%20simple%20background%2C%20product%20photography%20style%2C%20high%20resolution%20detail%20shot&width=600&height=600&seq=purrfect-jute-detail&orientation=squarish",
  },
  {
    id: 2,
    name: "Sturdy Wood Base",
    description: "Solid particle board\nEPA TSCA Title VI compliant",
    param: '12.8" Wide',
    image: "https://readdy.ai/api/search-image?query=Top-down%20view%20of%20a%20round%20wooden%20platform%20base%20with%20four%20small%20anti-slip%20rubber%20pads%20in%20corners%2C%20warm%20natural%20wood%20grain%20texture%2C%20clean%20product%20photography%2C%20soft%20even%20lighting%2C%20minimal%20studio%20background%2C%20elegant%20home%20decor%20aesthetic&width=600&height=600&seq=purrfect-wood-base&orientation=squarish",
  },
  {
    id: 3,
    name: "Recyclable Materials",
    description: "Eco-conscious design\nSustainable pet product",
    param: "Eco-Friendly",
    image: "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20recyclable%20cardboard%20and%20natural%20fiber%20materials%20arranged%20artfully%2C%20warm%20earth%20tones%2C%20soft%20studio%20lighting%2C%20sustainable%20eco-friendly%20aesthetic%2C%20clean%20background%2C%20green%20living%20concept&width=600&height=600&seq=purrfect-eco-materials&orientation=squarish",
  },
  {
    id: 4,
    name: "Play Ball Toy",
    description: "Interactive dangling ball\nEncourages active play",
    param: "Included",
    image: "https://readdy.ai/api/search-image?query=Close-up%20of%20a%20small%20round%20fabric%20ball%20toy%20tied%20with%20natural%20twine%20rope%20hanging%20from%20the%20neck%20of%20a%20wine%20bottle%20shaped%20cat%20scratcher%2C%20warm%20amber%20lighting%2C%20cozy%20home%20interior%20background%2C%20pet%20product%20photography&width=600&height=600&seq=purrfect-ball-toy&orientation=squarish",
  },
  {
    id: 5,
    name: "Indoor Design",
    description: "Compact footprint\nFits any room aesthetic",
    param: '22.6" Tall',
    image: "https://readdy.ai/api/search-image?query=Elegant%20wine%20bottle%20shaped%20cat%20scratcher%20in%20a%20stylish%20modern%20living%20room%20corner%20next%20to%20a%20wine%20cabinet%2C%20warm%20amber%20and%20brown%20tones%2C%20soft%20ambient%20lighting%2C%20cozy%20home%20interior%2C%20minimalist%20decor%2C%20lifestyle%20product%20photography&width=600&height=600&seq=purrfect-lifestyle-room&orientation=squarish",
  },
];

export const assemblySteps = [
  {
    step: 1,
    title: "Attach the Post",
    description:
      "Connect the bottle post to the base platform using Screw A and Washer B.",
  },
  {
    step: 2,
    title: "Tie the Ball",
    description: "Tie the play ball to the neck of the bottle for interactive fun.",
  },
  {
    step: 3,
    title: "Add Anti-Slip Pads",
    description:
      "Attach the 4 anti-slip pads to the bottom corners of the base for stability.",
  },
];

export const reviews = [
  {
    id: 1,
    rating: 5,
    title: "Looks Like a Sculpture",
    content:
      "This doesn't look like a cat scratcher at all — it looks like a piece of art. Guests always ask about it. My cat took to the jute rope immediately and scratches it daily.",
    user: "Sarah L.",
    pet: "British Shorthair · Pudding",
    avatar: "SL",
  },
  {
    id: 2,
    rating: 5,
    title: "Assembly Was a Breeze",
    content:
      "Literally took me 5 minutes to put together. The included Allen wrench is all you need. The base is super stable even when my cat leaps onto it at full speed.",
    user: "Mike Z.",
    pet: "American Shorthair · Cola",
    avatar: "MZ",
  },
  {
    id: 3,
    rating: 5,
    title: "A Wine Lover's Dream",
    content:
      "As a wine enthusiast, I couldn't resist the bottle design. It sits perfectly next to my wine rack. The Cabernet Red color is gorgeous in person — even richer than the photos.",
    user: "Emma W.",
    pet: "Ragdoll · Snowball",
    avatar: "EW",
  },
  {
    id: 4,
    rating: 5,
    title: "Compact and Stylish",
    content:
      "At just under 23 inches tall, it fits perfectly in my small apartment. Doesn't take up much floor space but my cat uses it constantly. The anti-slip pads keep it firmly in place.",
    user: "David C.",
    pet: "Orange Tabby · Yolk",
    avatar: "DC",
  },
  {
    id: 5,
    rating: 5,
    title: "Best Gift for Cat Parents",
    content:
      "Bought this as a housewarming gift for my cat-loving friend. She screamed when she opened it! The packaging alone feels premium and gift-worthy. Highly recommend.",
    user: "Linda K.",
    pet: "Siamese · Shadow",
    avatar: "LK",
  },
  {
    id: 6,
    rating: 4,
    title: "Great Quality for the Price",
    content:
      "The jute rope is thick and well-wrapped, and the wood base feels solid. No chemical smell out of the box. My only wish is that it came in more colors — I'd buy another one!",
    user: "Jason T.",
    pet: "Maine Coon · Fluff",
    avatar: "JT",
  },
];